<template>
    <div :class="avatarClass">
        <img v-if="imageExist"
            class="rounded-circle"
            :class="{'avatar-shadow':shadow,'avatar-bordered':border}"
            :src="img"
            :alt="altText ? altText : $t('not_found')">
        <div v-else class="no-img rounded-circle" :class="{'avatar-shadow':shadow,'avatar-bordered':border}">
            {{ title ? title : 'AV' | titleFilter }}
        </div>
        <span v-if="status" class="status" :class="'bg-'+status"/>
    </div>
</template>

<script>
import {toRaw} from "vue";

export default {
    name : "AppAvatar",
    props: {
        avatarClass: {
            type   : String,
            require: true
        },
        img        : {
            type   : String,
            require: true
        },
        altText    : {
            type: String
        },
        shadow     : {
            type   : Boolean,
            default: false
        },
        title      : {
            type: String
        },
        status     : {
            type   : String,
            default: null
        },
        border     : {
            type   : Boolean,
            default: false
        }
    },
    data() {
        return {
            imageExist: false
        }
    },
    watch: {
        'img': {
            handler  : async function (value) {
                if (value && !this.imageExist) {
                    try {
                        const res       = await fetch(value, {method: 'HEAD'});
                        this.imageExist = res.ok && res.headers.get('content-type')?.startsWith('image/');
                    } catch (err) {
                        this.imageExist = false;
                    }
                }
            },
            immediate: true
        },
    },
    async mounted() {
        if (this.img) {
            try {
                const res       = await fetch(this.img, {method: 'HEAD'});
                this.imageExist = res.ok && res.headers.get('content-type')?.startsWith('image/');
            } catch (err) {
                this.imageExist = false;
            }
        }
    },
    filters: {
        titleFilter(str) {
            str            = str.replace(/(^\s*)|(\s*$)/gi, "");
            str            = str.replace(/[ ]{2,}/gi, " ");
            str            = str.replace(/\n /, "\n");
            let titleArray = str.split(' ');
            if (titleArray.length > 1) {
                return (titleArray[0][0] + titleArray[1][0]).toLocaleUpperCase();
            } else {
                return titleArray[0].substring(0, 2).toLocaleUpperCase();
            }
        },
    }
}
</script>
